<template>
  <b-modal
    id="add-new-scholarship-modal"
    ref="add-new-scholarship-modal"
    centered
    size="lg"
    :title="$t('Add new scholarship')"
    title-class="font-weight-bolder"
    ok-only
    :ok-title="$t('Save')"
    @ok.prevent="addNewScholarship"
  >
    <scholarship-item ref="scholarship-item" />
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal
} from 'bootstrap-vue'
import { useScholarship } from '@mentoring-platform/composables'
import ScholarshipItem from '@mentoring-platform/views/components/blocks/Scholarships/ScholarshipItem.vue'

export default {
  components: {
    BButton,
    BModal,
    ScholarshipItem
  },
  data() {
    return {

    }
  },
  methods: {
    show() {
      this.$refs['add-new-scholarship-modal'].show()
    },
    async addNewScholarship() {
      const isValid = await this.$refs['scholarship-item'].isValid()
      if(isValid) {
        const payload = this.$refs['scholarship-item'].collectData()
        this.createScholarship(payload)
          .then(response => {
            this.$root.$bvToast.toast(this.$t('Scholarship successfully added'), {
              title: this.$t('Confirmation'),
              variant: 'success',
              solid: true,
            })
            this.$refs['add-new-scholarship-modal'].hide()
            this.$bus.$emit('scholarships-list-needs-refresh')
          })
          .catch(error => {
            this.$root.$bvToast.toast(this.$t('An error occured, please try again later'), {
              title: this.$t('Caution'),
              variant: 'danger',
              solid: true,
            })
          })
      }
    }
  },
  setup() {
    const { createScholarship } = useScholarship()

    return {
      createScholarship
    }
  }
}
</script>

<style scoped>

</style>
